/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCategory: 'awaitingShipment', // 'awaitingShipment' | 'shipped'
  activeSubcategory: 'all', // awaiting: 'all'|'recent' — shipped: 'all'|'today'|'yesterday'|'recent'|'voided'
  activeFacility: 'all', // 'all' | pharmacyId
  counts: {
    loading: false,
    awaiting: {
      total: 0,
      recent: 0,
      byPharmacy: {},
      recentByPharmacy: {},
    },
    shipped: {
      all: 0,
      today: 0,
      yesterday: 0,
      recent: 0,
      voided: 0,
      allByPharmacy: {},
      todayByPharmacy: {},
      yesterdayByPharmacy: {},
      recentByPharmacy: {},
      voidedByPharmacy: {},
    },
  },
  list: {
    currentPage: 1,
    pages: {},
    count: 0,
    loading: false,
    filter: {},
    sortBy: { sortKey: 'createdAt', sortOrder: 'DESC' },
  },
};

const toByPharmacyMap = (byPharmacy) => {
  const map = {};
  byPharmacy.forEach(({ fulfillingPharmacyId, count }) => {
    map[fulfillingPharmacyId] = count;
  });
  return map;
};

const shipstationShipmentSlice = createSlice({
  name: 'shipstationShipment',
  initialState,
  reducers: {
    setActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
      state.activeSubcategory = 'all';
      state.activeFacility = 'all';
      state.list.currentPage = 1;
      state.list.pages = {};
    },
    setActiveSubcategory: (state, action) => {
      state.activeSubcategory = action.payload;
      // Preset/subcategory changes don't reset the facility selection — they are independent axes.
      state.list.currentPage = 1;
      state.list.pages = {};
    },
    setActiveFacility: (state, action) => {
      state.activeFacility = action.payload;
      state.list.currentPage = 1;
      state.list.pages = {};
    },
    setCountsLoading: (state, action) => {
      state.counts.loading = action.payload;
    },
    setAllCounts: (state, action) => {
      const {
        awaitingAll,
        awaitingRecent,
        shippedAll,
        shippedToday,
        shippedYesterday,
        shippedRecent,
        shippedVoided,
      } = action.payload;
      state.counts.awaiting = {
        total: awaitingAll.total,
        recent: awaitingRecent.total,
        byPharmacy: toByPharmacyMap(awaitingAll.byPharmacy),
        recentByPharmacy: toByPharmacyMap(awaitingRecent.byPharmacy),
      };
      state.counts.shipped = {
        all: shippedAll.total,
        today: shippedToday.total,
        yesterday: shippedYesterday.total,
        recent: shippedRecent.total,
        voided: shippedVoided.total,
        allByPharmacy: toByPharmacyMap(shippedAll.byPharmacy),
        todayByPharmacy: toByPharmacyMap(shippedToday.byPharmacy),
        yesterdayByPharmacy: toByPharmacyMap(shippedYesterday.byPharmacy),
        recentByPharmacy: toByPharmacyMap(shippedRecent.byPharmacy),
        voidedByPharmacy: toByPharmacyMap(shippedVoided.byPharmacy),
      };
      state.counts.loading = false;
    },
    setListLoading: (state, action) => {
      state.list.loading = action.payload;
    },
    loadListPage: (state, action) => {
      const { page, items, count } = action.payload;
      state.list.pages[page] = items;
      state.list.count = count;
      state.list.loading = false;
    },
    setCurrentPage: (state, action) => {
      state.list.currentPage = action.payload;
    },
    updateFilter: (state, action) => {
      state.list.filter = { ...state.list.filter, ...action.payload };
      state.list.currentPage = 1;
      state.list.pages = {};
    },
    resetFilter: (state) => {
      state.list.filter = {};
      state.list.currentPage = 1;
      state.list.pages = {};
    },
    updateSortBy: (state, action) => {
      state.list.sortBy = action.payload;
      state.list.currentPage = 1;
      state.list.pages = {};
    },
  },
});

export const shipstationShipmentActions = shipstationShipmentSlice.actions;
export default shipstationShipmentSlice.reducer;
